import React from 'react';
import { useTranslation } from 'react-i18next';
import { fmtNum, fmtPct } from '../../lib/formatHelpers';

/**
 * V2 IndicatorsGrid — Grid de KPIs avancés (sessions, durée, peak, gifters, etc.)
 * NoiRock adaptation : on prend les colonnes cleartext de creator_metrics_daily
 * + creator_current_month. Les colonnes manquantes (pcu_max, gifters,
 * avg_watch_duration) sont stubbées avec '—' ou cachées.
 */
const Tile = ({ label, value, sub, accent }) => (
  <div className="rounded-xl bg-card border border-border p-3 min-w-0">
    <div className="text-[10px] uppercase tracking-widest text-muted-foreground/70 font-semibold truncate">{label}</div>
    <div className={`text-xl md:text-2xl font-heading font-bold tabular-nums mt-1 truncate ${accent || 'text-foreground'}`}>
      {value}
    </div>
    {sub && <div className="text-[10px] text-muted-foreground mt-0.5 truncate">{sub}</div>}
  </div>
);

const IndicatorsGrid = ({
  newFollowers = 0,
  matches = 0,
  uniqueCreators = 0,
  totalCreators = 0,
  goLiveRate = null,
  avgSessions = null,
  avgHours = null,
  loading = false,
}) => {
  const { t } = useTranslation();
  const tiles = [
    {
      label: t('adminV2.indicators.uniqueCreators', 'Active creators'),
      value: loading ? '…' : fmtNum(uniqueCreators),
      sub: totalCreators > 0 ? `${fmtPct((uniqueCreators / totalCreators) * 100, 0)} of total` : null,
    },
    {
      label: t('adminV2.indicators.newFollowers', 'New followers'),
      value: loading ? '…' : fmtNum(newFollowers),
    },
    {
      label: t('adminV2.indicators.matches', 'Matches'),
      value: loading ? '…' : fmtNum(matches),
    },
    {
      label: t('adminV2.indicators.goLiveRate', 'Go-live rate'),
      value: loading ? '…' : (goLiveRate != null ? fmtPct(goLiveRate, 0) : '—'),
    },
    {
      label: t('adminV2.indicators.avgSessions', 'Avg sessions/creator'),
      value: loading ? '…' : (avgSessions != null ? avgSessions.toFixed(1) : '—'),
    },
    {
      label: t('adminV2.indicators.avgHours', 'Avg hours/creator'),
      value: loading ? '…' : (avgHours != null ? avgHours.toFixed(1) + 'h' : '—'),
    },
  ];

  return (
    <section className="space-y-3">
      <div className="text-xs uppercase tracking-widest text-muted-foreground/70 font-semibold px-1">
        {t('adminV2.indicators.title', 'Indicators')}
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
        {tiles.map((tile, i) => (
          <Tile key={i} {...tile} />
        ))}
      </div>
    </section>
  );
};

export default IndicatorsGrid;
